export const ordinalizeSuffix = (
  nr: number,
  locale: string = 'en',
  gender: 'm' | 'f' | 'n' | undefined = undefined,
) => {
  const lastDigit = nr % 10

  switch (locale) {
    case 'en':
      if (nr >= 10 && nr <= 19) {
        return `th`
      }
      if (lastDigit === 1) {
        return `st`
      }
      if (lastDigit === 2) {
        return `nd`
      }
      if (lastDigit === 3) {
        return `rd`
      }
      return `th`

    case 'it':
    case 'pt':
      return (gender === 'f') ? `ª` : `º`

    case 'es':
      return (gender === 'f') ? `.ª` : `.º`

    case 'fr':
      if (nr === 1) {
        return (gender === 'f') ? `ʳᵉ` : `ᵉʳ`
      }
      return `ᵉ`

    case 'de':
    case 'hu':
    default:
      return `.`
  }
}

const ordinalize = (
  nr: number,
  locale: string = 'en',
  gender: 'm' | 'f' | 'n' | undefined = undefined,
) => `${nr}${ordinalizeSuffix(nr, locale, gender)}`

export default ordinalize
